import { call, put, takeLatest, takeEvery, delay, select } from 'redux-saga/effects';

import {
	getClients,
	getClientsSuccess,
	getClientsFailure,
	getDependents,
	getDependentsFailure,
	getDependentsSuccess,
	getClientById,
	getClientByIdSuccess,
	getClientByIdFailure,
	updateClient,
	updateClientSuccess,
	updateClientFailure,
	removeClient,
	removeClientSuccess,
	removeClientFailure,
	createClient,
	createClientSuccess,
	createClientFailure,
	getGenders,
	getGendersSuccess,
	getGendersFailure,
	getClientStatuses,
	getClientStatusesSuccess,
	getClientStatusesFailure,
	getMaritalStatuses,
	getMaritalStatusesSuccess,
	getMaritalStatusesFailure,
	getPlans,
	getPlansSuccess,
	getPlansFailure,
	getDeliveryPreferences,
	getDeliveryPreferencesSuccess,
	getDeliveryPreferencesFailure,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
} from '.';

import clientService from '../../../services/ClientService';

function* rootSaga() {
	yield takeLatest(getClients, getClientsSaga);
	yield takeLatest(getDependents, getDependentsSaga);
	yield takeLatest(getClientById, getClientByIdSaga);
	yield takeLatest(updateClient, updateClientSaga);
	yield takeLatest(removeClient, removeClientSaga);
	yield takeLatest(createClient, createClientSaga);
	yield takeLatest(getGenders, getGendersSaga);
	yield takeLatest(getClientStatuses, getClientStatusesSaga);
	yield takeLatest(getMaritalStatuses, getMaritalStatusesSaga);
	yield takeLatest(getPlans, getPlansSaga);
	yield takeLatest(getDeliveryPreferences, getDeliveryPreferencesSaga);
	yield takeLatest(downloadCsv, downloadCsvSaga);
}

function* getClientsSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getAll, payload);
		yield put(getClientsSuccess(response));
	} catch (error) {
		yield put(getClientsFailure(error));
	}
}

function* getDependentsSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getAllDependets, payload);
		yield put(getDependentsSuccess(response));
	} catch (error) {
		yield put(getDependentsFailure(error));
	}
}

function* getClientByIdSaga({ payload }) {
	const clientId = payload;
	try {
		yield delay(300);
		const response = yield call(clientService.getById, clientId);
		yield put(getClientByIdSuccess(response));
	} catch (error) {
		yield put(getClientByIdFailure(error));
	}
}

function* updateClientSaga({ payload }) {
	const { clientId: id, data: clientForm } = payload;
	try {
		yield delay(300);
		const response = yield call(clientService.update, id, clientForm);
		yield put(updateClientSuccess(response));

		// Refreshing the clients list since we edited one:
		const tableParams = yield select(({ clients }) => clients.clients.tableParams);
		yield put(getClients(tableParams));
	} catch (error) {
		yield put(updateClientFailure(error));
	}
}

function* removeClientSaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const response = yield call(clientService.remove, id);
		yield put(removeClientSuccess(response));

		// Refreshing the clients list since we removed one:
		const tableParams = yield select(({ clients }) => clients.clients.tableParams);
		yield put(getClients(tableParams));
	} catch (error) {
		yield put(removeClientFailure(error));
	}
}

function* createClientSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.create, payload);
		yield put(createClientSuccess(response));

		// Refreshing the clients list since we created one:
		const tableParams = yield select(({ clients }) => clients.clients.tableParams);
		yield put(getClients(tableParams));
	} catch (error) {
		yield put(createClientFailure(error));
	}
}

function* getGendersSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getGenders);
		yield put(getGendersSuccess(response));
	} catch (error) {
		yield put(getGendersFailure(error));
	}
}

function* getClientStatusesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getClientStatuses);
		yield put(getClientStatusesSuccess(response));
	} catch (error) {
		yield put(getClientStatusesFailure(error));
	}
}

function* getMaritalStatusesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getMaritalStatuses);
		yield put(getMaritalStatusesSuccess(response));
	} catch (error) {
		yield put(getMaritalStatusesFailure(error));
	}
}

function* getPlansSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getPlans);
		yield put(getPlansSuccess(response));
	} catch (error) {
		yield put(getPlansFailure(error));
	}
}

function* getDeliveryPreferencesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(clientService.getDeliveryPreferences);
		yield put(getDeliveryPreferencesSuccess(response));
	} catch (error) {
		yield put(getDeliveryPreferencesFailure(error));
	}
}

function* downloadCsvSaga({ payload }) {
	try {
		yield delay(300);
		yield call(clientService.downloadCsv, payload);
		yield put(downloadCsvSuccess());
	} catch (error) {
		yield put(downloadCsvFailure(error));
	}
}

export default rootSaga;
